import {InvalidConfigurationContextError} from './errors';
import {ShopifyFeatures} from './types';

export function readShopifyFeatures(): ShopifyFeatures {
  const shopifyFeaturesScript = document.querySelector('#shopify-features');
  if (!shopifyFeaturesScript) {
    throw new InvalidConfigurationContextError(
      'Failed to locate #shopify-features',
    );
  }
  return JSON.parse(
    shopifyFeaturesScript.textContent
      ? shopifyFeaturesScript.textContent
      : '{}',
  ) as ShopifyFeatures;
}
